export const COMMON_ERRORS = {
  NETWORK_ERROR: '00000',
  DUPLICATE_KEY: 'E11000',
};
